import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { Parcel } from 'app/core/app.model';
import { Branding } from 'app/core/auth/user.model';
import { ReportTitle } from 'app/core/report/report.model';
import { BrandingComponent } from '../branding/branding.component';
import { GoogleImageComponent } from '../google/google-image.component';
import { GoogleStreetViewImageComponent } from '../google/google-street-view-image.component';


@Component({
    selector: 'cover-modern',
    imports: [
        DatePipe,
        BrandingComponent,
        GoogleStreetViewImageComponent,
        GoogleImageComponent,
    ],
    styles: [
        `
        @media screen, print {
            .satellite,
            .map {
                width: 200px;
                margin: 0 30px 0 0;
            }
            .rounded-images {
                display: flex;
                position: relative;
                margin-top: -100px;
                margin-left: 400px;
                height: 200px;
            }
            .address {
                margin-top: -100px;
            }
            .address h2 {
                margin-top: 100px;
            }
            .main-image {
                width: 100%;
            }
            .top-image {
                width: 100%;
                min-height: 422px;
            }
            .top-image google-street-view-image {
                height: 422px;
            }
            h2 {
                text-transform: uppercase;
                font-weight: bold;
                font-size: 21px;
            }
            h1 {
                margin-top: 20px;
                font-size: 36px;
                font-weight: normal;
            }
            h3 {
                font-size: 21px;
            }
            .date {
                margin-top: 68px;
                font-size: 18px;
                text-transform: uppercase;
            }
            .address {
                padding: 0 30px;
            }
            .trademark-statement {
                position: absolute;
                bottom: 0px;
                right: 0px;
                padding-right: 25px;
                color: gray;
                font-size: 10px;
                max-width: 550px;
                text-align: right;
            }
            .content {
                position: absolute;
                top: 0;
                bottom: 0;
                width: 900px;
            }
            .custom-image {
                width: 100%;
            }
            .branding {
                position: absolute;
                bottom: 0;
                width: 100%;
                background: white;
            }
        }
        `,
    ],
    template: `
        <div class="content" [style.backgroundColor]="branding()?.background">
            <div class="main-image">
                <div class="top-image">
                    @if (image()) {
                        <img alt="" class="custom-image" [src]="image()">
                    }
                    @else {
                        <google-street-view-image
                            [width]="640"
                            [height]="300"
                            [clickToShow]="false"
                            [address]="parcel()"
                            [center]="parcel().geocenter">
                        </google-street-view-image>
                    }
                </div>
                <div class="rounded-images">
                    @if (showGoogleImages()) {
                        <div class="satellite">
                            <google-image
                                [width]="200"
                                [height]="200"
                                maptype="satellite"
                                shape="round"
                                [center]="parcel().geocenter"
                                [polygon]="parcel().geometry">
                            </google-image>
                        </div>
                        <div class="map">
                            <google-image
                                [width]="200"
                                [height]="200"
                                shape="round"
                                [center]="parcel().geocenter"
                                [polygon]="parcel().geometry">
                            </google-image>
                        </div>
                    }
                </div>
            </div>
            <div class="address" [style.color]="branding()?.color">
                <h2>Property Report</h2>
                <h1>
                    {{ title().addressLine1 }}
                    @if (title().addressLine2) {
                        <br>
                        {{ title().addressLine2 }}
                    }
                    <br>
                    {{ title().municipality }}
                    <br>
                    {{ title().postalCode }}
                    <br>
                    {{ parcel().countryLong }}
                </h1>
                <h3>
                    PID: {{ title().pid }}
                </h3>
                @if (!title().addressLine2) {
                    <br>
                }
                <p class="date">{{ createdAt() | date: 'MMMM d, yyyy' }}</p>
            </div>
        </div>
        <div class="branding">
            <branding-component
                type="reportType"
                [branding]="branding()"
                [creaTrademarkStatement]="creaTrademarkStatement()">
            </branding-component>
        </div>
    `,
})
export class CoverModernComponent {

    title = input.required<ReportTitle>();

    parcel = input.required<Parcel>();

    createdAt = input.required<string>();

    branding = input.required<Branding | null>();

    creaTrademarkStatement = input<string | null>(null);

    image = input<string | null>(null);

    showGoogleImages = input(true);
}
